__turbopack_context__.v({
  "navigation": "TermsNavigation-module-scss-module__HI9w5G__navigation",
  "navigation__button": "TermsNavigation-module-scss-module__HI9w5G__navigation__button",
  "navigation__button__active": "TermsNavigation-module-scss-module__HI9w5G__navigation__button__active",
  "swiper": "TermsNavigation-module-scss-module__HI9w5G__swiper",
  "swiper-slide": "TermsNavigation-module-scss-module__HI9w5G__swiper-slide",
});
